"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _context = require("../../context");
var Actions = _interopRequireWildcard(require("./"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useAddressActions = (dispatchFromProvider = null) => {
  const {
    state,
    dispatch
  } = (0, _react.useContext)(_context.AddressContext);
  const actions = {};
  Object.keys(Actions).map(actionName => {
    // eslint-disable-next-line import/namespace
    actions[actionName] = (...args) => Actions[actionName](...args)(state, dispatchFromProvider || dispatch);
  });
  actions.getState = () => state;
  return actions;
};
var _default = exports.default = useAddressActions;